/*
 * @Author: huangzq
 * @Date: 2020-03-05 16:54:49
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-09-27 01:14:27
 * @Desc: 左侧分组-组件二级菜单-员工二维码组件-效果组件-服务商1.0.1新增
*/
<template>
  <div class="sale-qrcode-set">
    <div>
      <span
        class="title"
        :class="{titleBlod:defaultData.titleBlod||true}"
      >员工二维码</span>
      <mk-popover
        :visible-arrow="false"
        placement="bottom"
        trigger="hover"
        popper-class="mk-group-poster-components-popper-class"
      >
        <div style="max-width:367px; font-size:12px; color:#595959; line-height:20px;">
          <slot name="tips">
            <p>1、添加员工二维码后，员工可在海报指定位置生成自己的企微二维码 </p>
            <p>2、扫码可添加员工为好友</p>
          </slot>
        </div>
        <mk-iconfont
          slot="reference"
          icon-class="icon-mk-tishi2"
        />
      </mk-popover>
    </div>
    <mk-switch
      :value="isShowQRCode"
      @change="value=>$emit('change', value)"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'SaleQrcodeSet',
  model: {
    prop: 'isShowQRCode',
    event: 'change'
  },
  props: {
    defaultData: {
      type: Object,
      default () {
        return {}
      }
    },
    // switch是否开启
    isShowQRCode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang='scss' scoped>
.sale-qrcode-set {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 20px;

  .title {
    font-size: 14px;
    color: #262626;
    margin-right: 5px;
  }

  .titleBlod {
    font-weight: 500;
  }

  .icon-mk-tishi2 {
    color: #a1a1a1;

    @extend .cursor;

    &:hover {
      color: #009cff;
    }
  }

  .mk-switch {
    margin-left: 15px;
  }
}
</style>
